import PuzzleService from '_services/rest/modules/puzzle';
import { handleResourceLoadError } from '_utils';

export default {
  state: {
    puzzleFences: null,
    hasChanges: false,
    enableExport: true,
  },
  mutations: {
    setPuzzleFences(state, puzzleFences) {
      state.puzzleFences = puzzleFences;
    },
    setHasChanges(state, status) {
      state.hasChanges = status;
    },
    setEnableExport(state, status) {
      state.enableExport = status;
    },
  },
  actions: {
    setPuzzleFences({ commit }, model) {
      commit('setPuzzleFences', model);
    },
    setHasChanges({ commit }, status) {
      commit('setHasChanges', status);
    },
    setEnableExport({ commit }, status) {
      commit('setEnableExport', status);
    },
    getPuzzleFences({ commit, dispatch }, id) {
      return PuzzleService.getPuzzleById(id)
        .then(response => {
          commit('setPuzzleFences', response);
          commit('setHasChanges', false);
        })
        .catch(error => {
          handleResourceLoadError(dispatch, error, 'admin-puzzle-fences-list');
        });
    },
  },
};
